"use client";

import cn from "classnames";

import { Affirm } from "@/components/affirm/affirm.component";

import { useSettings } from "@/contexts/settingsProvider.context";
import { GetProductQueryResult } from "@/sanity.types";

export const FinanceMessage = ({
  product,
  value,
  className,
}: FinanceMessageProps) => {
  const settings = useSettings();
  if (!value || !settings?.enableAffirm) return null;
  if (!product?.type || !["kit", "camera"].includes(product.type)) {
    return null;
  }
  const monthlyAmount = Number((value / 36).toFixed(2));
  if (!monthlyAmount) return null;
  return (
    <div
      data-testid="finance-message"
      className={cn(className, "mt-[1.5px] flex [&_a]:underline")}>
      <Affirm productId={product.id} amount={value} />
    </div>
  );
};

export type FinanceMessageProps = {
  product: GetProductQueryResult;
  value?: number;
  className?: string;
};
